import { css } from '@emotion/react'
import colors from '@mathflat/common/style/colors'

const S = {
  input: css`
    display: none;

    &:disabled + label {
      cursor: auto;
      color: ${colors.gray.$600};
      border: 1px solid ${colors.gray.$200};
      background: #fff;
    }

    &:checked:not(:disabled) + label {
      border: solid 1px ${colors.blue.$200};
      background-color: ${colors.blue.$100};
      color: ${colors.blue.$300};
    }
  `,
  label: css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 9px 12px;
    border: 1px solid ${colors.borderColor};
    border-radius: var(--Radius-100);
    color: ${colors.gray.$700};
    background-color: white;
    white-space: pre;
    cursor: pointer;

    &.rounded {
      padding: 8px 16px;
      border-radius: var(--Radius-Circle);
    }

    &:hover {
      background-color: ${colors.gray.$100};
    }
  `,
}

export default S
